import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import { DomainPickerField } from '../fields/DomainPicker';
import {
  domainPickerUiOptionsSchema,
  domainPickerValueSchema,
} from '../schemas/domainPickerSchema';

export const domainPickerFieldExtension: any = FormFieldBlueprint.make({
  name: 'domain-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'DomainPicker',
        component: DomainPickerField,
        schema: makeFieldSchema({
          output: () => domainPickerValueSchema,
          uiOptions: () => domainPickerUiOptionsSchema,
        }),
      }),
  },
});
